<template>
  <div class="holidayguru">
    <HgFooterNew
      :lang="lang"
      :activate-cookie-consent="!noCookieConsent"
      :showAccessibilityDeclaration="true"
      @onCookieButtonClick="cookieButtonClick"
      @onNewsletterButtonClick="newsletterButtonClick"
    />
  </div>
</template>

<script>
import { HgFooterNew } from "@holidayguru/holidayguru-components"

export default {
  components: {
    HgFooterNew
  },
  props: {
    locale: {
      type: String,
      default: null
    },
    cookieFunction: {
      type: Function,
      default: null
    }
  },
  created() {
    if (this.locale) {
      this.lang = this.locale
    } else if (window.location.host.includes(".at")) {
      this.lang = "at"
    } else if (window.location.host.includes(".ch")) {
      this.lang = "ch"
    } else if (window.location.host.includes(".es")) {
      this.lang = "es"
    } else if (window.location.host.includes(".nl")) {
      this.lang = "nl"
    } else {
      this.lang = "de"
    }
  },
  methods: {
    newsletterButtonClick() {
      window.location.href = "/newsletter"
    },
    cookieButtonClick() {
      if (this.cookieFunction) {
        this.cookieFunction()
      } else {
        window._sp_.gdpr.loadPrivacyManagerModal(
          this.$i18n.messages[this.lang].privacyManagerModalId
        )
      }
    }
  }
}
</script>

<style lang="postcss">
.hg-button {
  white-space: nowrap;
}
</style>
